import React, { FC, useState, useEffect } from "react";
import Banner from "../components/banner";
// import Telegram from "../assets/svg/telegram.svg";
import PFP from "../assets/logo/logo.gif";
import StaticPFP from "../assets/logo/logo.jpeg";
import X from "../assets/svg/x.svg";
import Youtube from "../assets/svg/Youtube.svg";
import Birdeye from "../assets/svg/Birdeye.svg";
import Solana from "../assets/svg/Solana.svg";
import Raydium from "../assets/svg/Raydium.svg";
import Pond from "../assets/svg/pond0x.svg";
import Anchor from "../components/anchor";
import styled from "@emotion/styled";
import Grid from "../components/grid";
import Stack from "../components/stack";
import Contract from "../components/copy";
import Responsive from "../components/responsive";

const ImageWrapper = styled.div({
  width: 60,
  height: 60,
  background: "rgba(0,0,0,0.3)",
  borderRadius: 100,
  padding: 12,
  borderBottom: "1px solid rgba(255,255,255,0.5)",
  "&:hover": {
    background: "rgba(0,0,0,0.6)",
  },
});

const Image = styled.img({
  width: "100%",
  height: "100%",
  filter: "drop-shadow(0 2px 0px rgba(0,0,0,0.2))",
});

const GridIcons: FC = () => {
  return (
    <>
      <Anchor
        href="https://www.youtube.com/@ronsbasement/community"
        target="_blank"
      >
        <ImageWrapper>
          <Image src={Youtube} alt="Youtube - Rons Basement" />
        </ImageWrapper>
      </Anchor>
      <Anchor href="https://x.com/BasementRon" target="_blank">
        <ImageWrapper>
          <Image src={X} alt="BasementRon on X" />
        </ImageWrapper>
      </Anchor>
      <Anchor
        href="https://www.birdeye.so/token/eL5fUxj2J4CiQsmW85k5FG9DvuQjjUoBHoQBi2Kpump?chain=solana"
        target="_blank"
      >
        <ImageWrapper>
          <Image src={Birdeye} alt="Birdeye" />
        </ImageWrapper>
      </Anchor>
      <Anchor
        href="https://raydium.io/swap/?inputMint=sol&outputMint=eL5fUxj2J4CiQsmW85k5FG9DvuQjjUoBHoQBi2Kpump"
        target="_blank"
      >
        <ImageWrapper>
          <Image src={Raydium} alt="Raydium" />
        </ImageWrapper>
      </Anchor>
      <Anchor
        href="https://solscan.io/token/eL5fUxj2J4CiQsmW85k5FG9DvuQjjUoBHoQBi2Kpump"
        target="_blank"
      >
        <ImageWrapper>
          <Image src={Solana} alt="Solana" />
        </ImageWrapper>
      </Anchor>

      <Anchor
        href="https://www.pond0x.com/swap/solana/eL5fUxj2J4CiQsmW85k5FG9DvuQjjUoBHoQBi2Kpump?ref=HMNMxzNbv2oADM4QzGFtTYDAMCJNmk8yPz9rN3zVdKC3uBKPQAZHfb2ey3g9"
        target="_blank"
      >
        <ImageWrapper>
          <Image src={Pond} alt="Pond0x" />
        </ImageWrapper>
      </Anchor>
    </>
  );
};

const Intro: FC = () => {
  const [isGifPlayed, setIsGifPlayed] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsGifPlayed(false);
    }, 3700);

    return () => clearTimeout(timer);
  }, []);

  return (
    <Banner
      pfp={isGifPlayed ? PFP : StaticPFP}
      placeholder={StaticPFP}
      heading="Unicorn Fart Dust"
      description="Introducing the Unicorn Fart Dust meme coin, your opportunity to own something worthless?"
    >
      <Stack
        direction="VERTICAL"
        space={"var(--scale-36)"}
        localStyles={{ alignItems: "center" }}
      >
        <Contract contractId="eL5fUxj2J4CiQsmW85k5FG9DvuQjjUoBHoQBi2Kpump" />

        <Responsive below={599}>
          <Grid columns={3} gap="var(--scale-24)">
            <GridIcons />
          </Grid>
        </Responsive>

        <Responsive above={600}>
          <Grid columns={6} gap="var(--scale-24)">
            <GridIcons />
          </Grid>
        </Responsive>
      </Stack>
    </Banner>
  );
};

export default Intro;
